__turbopack_context__.v({
  "className": "SB_bIG_className",
  "variable": "SB_bIG_variable",
});
